import { ArrowUpRight } from "lucide-react";
import { FadeUp, Eyebrow } from "@/components/reveal";

const ITEMS = [
    "Governments & port authorities",
    "Leading innovation hubs",
    "Family offices & sovereign investors",
    "Climate & venture funds",
    "Global shipping & logistics operators",
];

const Network = () => (
    <section
        id="network"
        data-testid="network-section"
        className="bg-night py-24 text-paper lg:py-32"
    >
        <div className="container-x grid gap-14 lg:grid-cols-12">
            <div className="lg:col-span-5">
                <FadeUp>
                    <Eyebrow light>Network</Eyebrow>
                </FadeUp>
                <FadeUp delay={0.1}>
                    <h2 className="mt-6 font-serif text-4xl leading-[1.08] tracking-tight sm:text-5xl lg:text-6xl">
                        Who we bring to{" "}
                        <em className="italic text-olive-light">the table</em>
                    </h2>
                </FadeUp>
                <FadeUp delay={0.2}>
                    <p className="mt-6 max-w-sm text-lg leading-relaxed text-paper/60">
                        A focused firm with a global reach — working alongside the
                        institutions that build, fund and operate infrastructure.
                    </p>
                </FadeUp>
            </div>

            <div className="lg:col-span-7">
                <ul>
                    {ITEMS.map((item, i) => (
                        <FadeUp key={item} delay={i * 0.07}>
                            <li
                                data-testid={`network-item-${i + 1}`}
                                className="group flex items-center gap-6 border-t border-paper/10 py-7 transition-all duration-500 hover:pl-4 lg:py-8"
                            >
                                <span className="font-mono text-xs text-olive-light">
                                    {String(i + 1).padStart(2, "0")}
                                </span>
                                <span className="flex-1 font-serif text-2xl leading-snug sm:text-3xl">
                                    {item}
                                </span>
                                <ArrowUpRight className="h-5 w-5 shrink-0 text-paper/30 transition-colors duration-300 group-hover:text-gold" />
                            </li>
                        </FadeUp>
                    ))}
                </ul>
            </div>
        </div>
    </section>
);

export default Network;
